export enum AppName {
    DCIDE = 'DCIDE',
    REPLUS = 'RE+Source PRO',
}
